module.exports = "/assets/site/images/MVM_evezes.jpg?5eff9ad7946d936b95d65ffb5f20eabf";